import React from 'react';
import { motion } from 'framer-motion';
const benefits = [{
  icon: '📋',
  title: 'El Protocolo Exacto de 7 Minutos',
  desc: 'Paso a paso, sin teoría aburrida. Solo lo que funciona.'
}, {
  icon: '💪',
  title: 'La Técnica de Bombeo Isométrico 3-2-2',
  desc: 'Desarrollada para fortalecer la base vascular sin equipo, sin gimnasio, sin testigos.'
}, {
  icon: '🫁',
  title: 'El Método de Respiración de Emergencia',
  desc: 'Para esos momentos donde la ansiedad amenaza con arruinar todo. La dominas en 3 minutos.'
}, {
  icon: '🥗',
  title: 'Los 5 Alimentos Económicos que Potencian el Óxido Nítrico',
  desc: 'Nada de suplementos caros. Ingredientes que encuentras en cualquier supermercado.'
}, {
  icon: '🔄',
  title: 'La Guía de Mantenimiento Permanente',
  desc: "Para que esto no sea 'una noche de suerte', sino tu nueva normalidad."
}];
export function BenefitsSection() {
  return <section className="py-20 px-4 bg-slate-900 border-y border-slate-800" data-id="element-30">
      <div className="max-w-4xl mx-auto" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-32">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-33">
            En Menos de 10 Minutos Desde Ahora, Tendrás en Tus Manos:
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto rounded-full" data-id="element-34"></div>
        </motion.div>

        <div className="bg-slate-950 p-8 md:p-10 rounded-3xl border border-slate-800 shadow-xl" data-id="element-35">
          <ul className="space-y-8" data-id="element-36">
            {benefits.map((item, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} className="flex items-start gap-4" data-id="element-37">
                <span className="text-3xl shrink-0 mt-1" data-id="element-38">{item.icon}</span>
                <div data-id="element-39">
                  <h3 className="text-xl font-bold text-slate-200 mb-1" data-id="element-40">
                    {item.title}
                  </h3>
                  <p className="text-slate-400 leading-relaxed" data-id="element-41">{item.desc}</p>
                </div>
              </motion.li>)}
          </ul>

          <div className="mt-12 flex flex-col items-center" data-id="element-42">
            <a href="#comprar" className="flex justify-center items-center w-full max-w-md bg-blue-600 hover:bg-blue-500 text-white font-bold text-lg py-4 px-8 rounded-full transition-all duration-300 shadow-[0_0_20px_rgba(37,99,235,0.4)] hover:shadow-[0_0_30px_rgba(37,99,235,0.6)] hover:scale-105 active:scale-95" data-id="element-43">
              Quiero el Protocolo + Bonos
            </a>
            <p className="text-slate-500 text-sm mt-3" data-id="element-44">
              Acceso inmediato al protocolo completo + bonos
            </p>
          </div>
        </div>
      </div>
    </section>;
}